export default "__VITE_ASSET__lt0ADXuD__"